module.exports = __webpack_public_path__ + "static/img/why4.34f71e36.png";